import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, useTheme } from '@mui/material';

interface MobileOutcomeButtonProps {
  outcomeLabel: string;
  outcomeColor: string;
  isNoOutcome: boolean;
  price?: string | number;
  onClick?: () => void;
}

export function MobileOutcomeButton({
  outcomeLabel,
  outcomeColor,
  isNoOutcome,
  price,
  onClick,
}: MobileOutcomeButtonProps) {
  const theme = useTheme();

  const displayPrice = price !== undefined ? `${(Number(price) * 100).toFixed(0)}¢` : '';

  return (
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={<RefreshIcon sx={{ fontSize: '1rem' }} />}
      sx={{
        bgcolor: outcomeColor,
        color: '#ffffff',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.9375rem',
        px: 2,
        py: 1,
        borderRadius: '8px',
        mb: 3,
        boxShadow: 'none',
        '&:hover': {
          bgcolor: isNoOutcome ? theme.palette.error.dark : '#16a34a',
          boxShadow: 'none',
        },
      }}
    >
      <span>{outcomeLabel}</span>
      {displayPrice && <span className="ml-2">{displayPrice}</span>}
    </Button>
  );
}
